import { getAuth } from "firebase/auth";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CreateHolidays from "../../../../Controllers/Admin/Holidays/CreateHolidays";
import GetSingleHolidays from "../../../../Controllers/Admin/Holidays/GetSingleHolidays";
import UpdateHolidays from "../../../../Controllers/Admin/Holidays/UpdateHolidays";
import GetUser from "../../../../Controllers/Users/GetUser";
import { ToastSuccessMessages } from "../../../../Helpers/ToastMessages";

export default function AddHolidaysViewModel() {
  const navigate = useNavigate();
  const location = useLocation();
  const [SchoolID, setSchoolID] = useState("");

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("schoolId"));
    setSchoolID(items);
  }, []);

  const [HolidaysIDD, setHolidaysIDD] = useState("");

  const [AuthUser, setAuthUser] = useState("");

  const [HolidaysNameError, setHolidaysNameError] = useState(false);
  const [HolidaysTypeError, setHolidaysTypeError] = useState(false);
  const [HolidaysStartDateError, setHolidaysStartDateError] = useState(false);
  const [HolidaysEndDateError, setHolidaysEndDateError] = useState(false);

  const [FormDisabled, setFormDisabled] = useState(false);
  const [IsUpdate, setIsUpdate] = useState(false);

  const [IsCheckError, setIsCheckError] = useState(false);
  const [AddHolidays, setAddHolidays] = useState({
    HolidaysID: "",
    HolidaysName: "",
    HolidaysType: "",
    HolidaysStartDate: "",
    HolidaysEndDate: "",
  });

  useEffect(() => {
    const LocationArray = location.pathname.split("/");
    setHolidaysIDD(LocationArray.pop());

    if (LocationArray.includes("update")) {
      setIsUpdate(true);
      const fetchData = async () => {
        const HolidaysData = await GetSingleHolidays(HolidaysIDD);
        setAddHolidays({
          HolidaysID: HolidaysData?.HolidaysID,
          HolidaysName: HolidaysData?.HolidaysName,
          HolidaysType: HolidaysData?.HolidaysType,
          HolidaysStartDate: HolidaysData?.HolidaysStartDate,
          HolidaysEndDate: HolidaysData?.HolidaysEndDate,
        });
      };
      fetchData();
    } else {
    }
  }, [location.pathname, HolidaysIDD]);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);
        setAuthUser(UserData);
      });
    }
    fetchData();
  }, []);

  const UIErrorHandling = useCallback(() => {
    let flag = 0;

    if (
      AddHolidays.HolidaysName === "" ||
      AddHolidays.HolidaysName === null ||
      AddHolidays.HolidaysName === undefined ||
      AddHolidays.HolidaysName.length < 3
    ) {
      setHolidaysNameError(true);
      flag++;
    } else {
      setHolidaysNameError(false);
    }

    if (
      AddHolidays.HolidaysType === "" ||
      AddHolidays.HolidaysType === null ||
      AddHolidays.HolidaysType === undefined
    ) {
      setHolidaysTypeError(true);
      flag++;
    } else {
      setHolidaysTypeError(false);
    }

    if (
      AddHolidays.HolidaysStartDate === "" ||
      AddHolidays.HolidaysStartDate === null ||
      AddHolidays.HolidaysStartDate === undefined
    ) {
      setHolidaysStartDateError(true);
      flag++;
    } else {
      setHolidaysStartDateError(false);
    }

    if (
      AddHolidays.HolidaysEndDate === "" ||
      AddHolidays.HolidaysEndDate === null ||
      AddHolidays.HolidaysEndDate === undefined
    ) {
      setHolidaysEndDateError(true);
      flag++;
    } else {
      setHolidaysEndDateError(false);
    }

    return flag;
  }, [
    AddHolidays.HolidaysName,
    AddHolidays.HolidaysType,
    AddHolidays.HolidaysStartDate,
    AddHolidays.HolidaysEndDate,
  ]);

  useEffect(() => {
    if (IsCheckError) UIErrorHandling();
  }, [IsCheckError, UIErrorHandling]);

  const RegisterHolidays = async () => {
    setIsCheckError(true);
    let flag = 0;
    flag = UIErrorHandling();

    if (flag === 0) {
      setFormDisabled(true);
      if (IsUpdate) {
        const HolidaysFinalObject = {
          ...AddHolidays,
        };

        await UpdateHolidays(HolidaysFinalObject, HolidaysIDD)
          .then(() => {
            ToastSuccessMessages("holiday/update-successful");
            navigate("/user/admin/holidays");
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        const HolidaysFinalObject = {
          ...AddHolidays,
        };

        await CreateHolidays(HolidaysFinalObject, AuthUser?.uid, SchoolID)
          .then(() => {
            ToastSuccessMessages("holiday/add-successful");
            navigate("/user/admin/holidays");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      setFormDisabled(false);
    }
  };

  return {
    RegisterHolidays,
    AddHolidays,
    setAddHolidays,
    HolidaysNameError,
    HolidaysTypeError,
    HolidaysStartDateError,
    HolidaysEndDateError,
    FormDisabled,
    IsUpdate,
  };
}
